var MARK = 'v1';
export { MARK };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/replay/esm/node_modules/rrweb/es/rrweb/packages/rrweb/src/packer/base.js
// module id = null
// module chunks = 